import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";

const UserContext = createContext({ userEmail: "", userName: "", userRole: "", loading: true });

export const UserProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUserEmail(user.email || "");
        try {
          const snap = await getDoc(doc(db, "users", user.uid));
          if (snap.exists()) {
            setUserRole(snap.data().role || "");
            setUserName(snap.data().name || "");
          }
        } catch (err) {
          console.error(err);
        }
      } else {
        setUserEmail("");
        setUserName("");
        setUserRole("");
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <UserContext.Provider value={{ userEmail, userName, userRole, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);

// Permission helpers
export const canAdd = (role) => role === "admin" || role === "superadmin";
export const canEdit = (role) => role === "admin" || role === "superadmin";
export const canDelete = (role) => role === "admin" || role === "superadmin";
export const canDeleteUser = (role) => role === "superadmin";
export const canManageAdmin = (role) => role === "admin" || role === "superadmin";
export const isSuperAdmin = (role) => role === "superadmin";
